<template>
  <div>
    <b-overlay :show="pageShow" rounded="sm">
      <div v-if="tableHeaderArray.length">
        <b-card no-body class="mb-1">
          <b-card-body class="py-1">
            <b-row class="d-flex justify-content-between px-1">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" variant="outline-primary" @click="$router.back()">
                  <feather-icon icon="ChevronLeftIcon" />
                </b-button>
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="editClick(0)">
                  <feather-icon icon="PlusIcon" class="mr-50" />
                  <span class="align-middle">数据项</span>
                </b-button>
            </b-row>
          </b-card-body>
        </b-card>

        <b-card>
          <vxe-grid ref="xGrid" v-bind="gridOptions">
            <template #radio_default="{ row, column }">
              {{ showParamsText(row, column) }}
            </template>
            <template #select_default="{ row, column }">
              {{ showParamsText(row, column) }}
            </template>
            <template #checkbox_default="{ row, column }">
              {{ showParamsText(row, column, 2) }}
            </template>
            <template #pic_default="{ row, column }">
              <viewer>
                <b-img :src="row[column.property]" height="32" width="32" class="d-inline-block"/>
              </viewer>
            </template>
            <template #pics_default="{ row, column }">
              <viewer>
                <b-img
                  v-for="(item,index) in row[column.property]"
                  :key="index"
                  :src="item"
                  height="32"
                  width="32"
                  class="d-inline-block mx-50"
                />
              </viewer>
            </template>
            <template #status_default="{ row }">
              <b-badge pill v-if="row.status" class="px-1 py-50" variant="light-primary"> 启用 </b-badge>
              <b-badge pill v-else class="px-1 py-50" variant="light-warning"> 禁用 </b-badge>
            </template>
            <template #action_default="{ row }">
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="row.pid > 0"
                  variant="flat-primary" class="btn-icon" size="sm"
                >
                  <feather-icon icon="ListIcon" class="cursor-pointer text-body" size="16" />
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="editClick(row)"
                  variant="flat-primary" class="btn-icon" size="sm"
                >
                  <feather-icon icon="EditIcon" class="cursor-pointer text-body" size="16" />
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="setStatus(row.id)"
                  variant="flat-primary" class="btn-icon" size="sm"
                >
                  <feather-icon :icon=" row.status ? 'ToggleLeftIcon':'ToggleRightIcon'" class="cursor-pointer text-body" size="16" />
              </b-button>
              <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="deleteGroupData(row.id)"
                  variant="flat-primary" class="btn-icon" size="sm"
                >
                  <feather-icon icon="Trash2Icon" class="cursor-pointer text-body" size="16" />
              </b-button>
            </template>
          </vxe-grid>
        </b-card>
      </div>
      <div v-else>
        <b-alert variant="danger" :show="!pageShow">
          <h4 class="alert-heading"> 获取数据项数据错误 </h4>
          <div class="alert-body">
            没有查询到对应数据组 ID 的数据, 您可以去
            <b-link
              class="alert-link ml-1"
              :to="{ name: 'combined-data'}"
            >
              组合数据
            </b-link>
            <span class="ml-1"> 查看其他的数据组 </span>
          </div>
        </b-alert>
      </div>
    </b-overlay>

    <!-- 编辑信息 -->
    <GroupDataEdit :info="infoValue" :header-array="customerFieldsParams" v-model="showEditModal" @up-ok="upDateGroupData" />
  </div>
</template>

<script>
// import vSelect from 'vue-select'
import { ref, watch, onMounted } from '@vue/composition-api'
import router from '@/router'
import Ripple from 'vue-ripple-directive'
import { groupDataHeader, groupDataList, groupDataStatus, groupDataDelete, groupDataSave } from '@/api/system/combined.js'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import GroupDataEdit from './GroupDataEdit.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    GroupDataEdit,
  },
  setup(props, context) {
    /* 必要组件加载区域 */

    // 权限组件 弹出确认组件
    const { $swal } = context.root
    // 消息提醒组件
    const toast = useToast()
    // 页面请求是否完成, 是否是有效的group_id参数
    const pageShow = ref(true)
    const group_id = ref(null)
    // 表头数据
    const tableHeaderArray = ref([])
    // 编辑表单自定义字段配置项
    const customerFieldsParams = ref([])
    // 表格配置 未来会迭代成后端配置项
    const gridOptions = ref({
      // 表格带边框
      border: true,
      // 动态大小变化跟随
      autoResize: true,
      // 自动隐藏超出的cell
      showOverflow: true,
      // 保持原始值的状态
      keepSource: true,
      // 加载状态控制
      loading: false,
      // 列配置
      columnConfig: {
        isCurrent: true,
        isHover: false,
        resizable: true,
      },
      // 行配置
      rowConfig: {
        isCurrent: true,
        isHover: false,
      },
      // 列数据
      columns: [],
      // 列表数据
      data: []
    })

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */

    // 编辑窗口状态
    const showEditModal = ref(false)
    // 待编辑的数据
    const infoValue = ref({ id: 0, sort: 0, status: true })

    /* 接口调用区域 方法处理 */
    // 编辑点击处理（来源 0 新增，row 有值来源为行编辑）
    const editClick = row => {
      if (row) {
        // 赋值对应的配置数据
        infoValue.value = JSON.parse(JSON.stringify(row))
      } else {
        // 修改编辑对话框组件的管理属性为初始状态
        infoValue.value = { id: 0, sort: 0, status: true }
      }
      showEditModal.value = true
    }

    // radio,select,checkbox等组件需要查询参数显示处理
    const showParamsText = (row, column, type = 1) => {
      // 单选情况
      if (type === 1) {
        // 判断参数是否是数组，如果不是直接返回空
        if (Array.isArray(column.params) && column.params.length) {
          // 判断数组中是否有此值对应的配置
          let filterParams = column.params.filter(item => item.value === row[column.property])
          if (filterParams.length) {
            // 处理多个值的情况，在配置参数值重复的情况下可能存在这个问题
            let textArray = []
            filterParams.map(item => { textArray.push(item.text) })
            return textArray.join('/')
          } else return ''

        } else return ''
      // checkbox 等多选，值是数组的情况
      } else if (type === 2) { 
        // 判断参数是否是数组，如果不是直接返回空
        if (Array.isArray(column.params) && column.params.length) {
          // 获取值中有的params数组 因为值可能是多个
          let filterParams = column.params.filter(item => row[column.property].includes(item.value))
          if (filterParams.length) {
            // 处理多个值的情况，在配置参数值重复的情况下可能存在这个问题
            let textArray = []
            filterParams.map(item => { textArray.push(item.text) })
            return textArray.join('/')
          } else return ''
        }
      } else return ''
    }

    // 获取数据组数据
    const fetchData = () => {
      gridOptions.value.loading = true
      groupDataList({ group_id: group_id.value })
        .then(res => {
          /* 由于组合数据中的自定义字段无法模型json对象，只能整理数据 */
          // 第一步，从header数组中获取自定义字段
          let customerFields = tableHeaderArray.value.filter(item => !(['id','sort','status'].includes(item.key)))
          // 第二步，整理 valueMap 中的数据
          res.data.forEach(item => {
            if (item.valueMap) {
              // 配置对应 key value 值
              customerFields.map(field => {
                // 这个判断用于处理新增字段后无数据报错问题, checkbox 状态下slots必须是数组的问题
                if (item.valueMap[field.key]) {
                  item[field.key] = item.valueMap[field.key].value
                } else {
                  ['checkbox'].includes(field.key) ? item[field.key] = [] : ''
                }
              })
            }
            return item
          })
          // 赋值给grid表格
          gridOptions.value.data = res.data
          gridOptions.value.loading = false
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '获取数据组数据失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 获取数据组表格头，同时确定是否是有效的 group_id
    const getHeader = id => {
      groupDataHeader({ group_id: id })
        .then(res => {
          // 处理group_id有效的问题
          group_id.value = Number(router.currentRoute.params.id)
          // 设置页面访问可见
          pageShow.value = false
          // 获取数据组对应的数据
          fetchData()
          // 存储表格头信息用户整理表格以及处理编辑对话框
          tableHeaderArray.value = res.data
          // 存放临时表格头数据
          let headerArray = []
          // 处理表个头问题 在表个头中已经默认添加了基础的表个头
          tableHeaderArray.value.map(item => {
            // 处理key => id 替换后台的部分信息，如果是表单直接使用配置项
            if (item.key === 'id') headerArray.push({ field: 'id', title: 'ID', width: 100, align: 'center', showOverflow: true })
            // 处理 key => sort
            else if (item.key === 'sort') headerArray.push({ field: 'sort', title: '排序', width: 80, align: 'center', showOverflow: true })
            // 处理 key => status
            else if (item.key === 'status') headerArray.push({
              field: 'status',
              title: '状态',
              width: 100,
              align: 'center',
              className: 'vxe-table-padding',
              slots: { default: 'status_default' }
            })
            // 处理 后端配置的key
            else {
              let tableColumn = { field: item.key, title: item.name }
              // 处理不同类型的type对应的列情况，比如 宽度，是否需要带样式是否是slots渲染
              if (item.type === 'input') {
                tableColumn.minWidth = 150
                tableColumn.showOverflow = true
              } else if (item.type === 'textarea') {
                tableColumn.minWidth = 250
                tableColumn.showOverflow = true
              } else if (item.type === 'radio') {
                tableColumn.minWidth = 150
                tableColumn.align = 'center'
                tableColumn.params = JSON.parse(item.param)
                tableColumn.slots = { default: 'radio_default' }
                tableColumn.showOverflow = true
              } else if (item.type === 'checkbox') {
                tableColumn.minWidth = 250
                tableColumn.align = 'center'
                tableColumn.params = JSON.parse(item.param)
                tableColumn.slots = { default: 'checkbox_default' }
                tableColumn.showOverflow = true
              } else if (item.type === 'select') {
                tableColumn.minWidth = 150
                tableColumn.align = 'center'
                tableColumn.params = JSON.parse(item.param)
                tableColumn.slots = { default: 'select_default' }
                tableColumn.showOverflow = true
              } else if (item.type === 'number') {
                tableColumn.minWidth = 120
                tableColumn.showOverflow = true
              } else if (item.type === 'upload') {
                tableColumn.minWidth = 80
                tableColumn.align = 'center'
                tableColumn.slots = { default: 'pic_default' }
              } else if (item.type === 'uploads') {
                tableColumn.minWidth = 200
                tableColumn.slots = { default: 'pics_default' }
              }
              headerArray.push(tableColumn)
            }
          })
          // 注入操作列
          headerArray.push({
            field: 'action',
            title: '操作',
            width: 130,
            align: 'center',
            fixed: 'right',
            className: 'vxe-table-padding',
            slots: { default: 'action_default' }
          })
          // 赋值给gridOptions
          gridOptions.value.columns = headerArray

          /* 开始处理编辑对话框中的自定义字段及组件控制问题 */
          // 获取自定义字段 显示的时候，处理编辑表单
          let fields = []
          tableHeaderArray.value.filter(item => item.type !== 'table').map(el => {
            let field = {}
            switch (el.type) {
              case 'input':
                field.param = el.key
                field.key = el.type
                field.type = 'text'
                field.component = 'input'
                field.label = el.name
                field.rules = 'required'
                field.value = ''
                break
              case 'textarea':
                field.param = el.key
                field.key = el.type
                field.type = 'text'
                field.component = 'textarea'
                field.label = el.name
                field.rules = 'required'
                field.value = ''
                break
              case 'radio':
                field.param = el.key
                field.key = el.type
                field.component = 'radio'
                field.label = el.name
                field.rules = 'required'
                field.value = null
                field.options = JSON.parse(el.param)
                break
              case 'checkbox':
                field.param = el.key
                field.key = el.type
                field.component = 'checkbox'
                field.label = el.name
                field.rules = 'required'
                field.value = []
                field.options = JSON.parse(el.param)
                break
              case 'select':
                field.param = el.key
                field.key = el.type
                field.component = 'select'
                field.label = el.name
                field.rules = 'required'
                field.value = null
                field.options = JSON.parse(el.param)
                break
              case 'number':
                field.param = el.key
                field.key = el.type
                field.type = 'number'
                field.number = true
                field.component = 'input'
                field.label = el.name
                field.rules = 'required'
                field.value = 0
                break
              case 'upload':
                field.param = el.key
                field.key = el.type
                field.component = 'pic'
                field.label = el.name
                field.rules = 'required'
                field.value = null
                break
              case 'uploads':
                field.param = el.key
                field.key = el.type
                field.component = 'pics'
                field.label = el.name
                field.rules = 'required'
                field.value = []
                break
              default: null
            }
            fields.push(field)
          })
          // 赋值给变量 customerFieldsParams
          customerFieldsParams.value = fields
        })
        .catch(err => {
          // 设置页面访问可见
          pageShow.value = false
          toast({
            component: ToastificationContent,
            props: { title: '数据错误', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 修改状态
    const setStatus = id => {
      groupDataStatus({ id })
        .then(() => {
          fetchData()
          toast({
            component: ToastificationContent,
            props: { title: '数据项状态修改成功', icon: 'CheckCircleIcon', variant: 'success' },
          })
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '数据项状态修改失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 删除数据组数据
    const deleteGroupData = id => {
      $swal({
        title: '删除数据组数据',
        text: '您正在删除数据组数据,某些状态被删除后系统将无法正常运行,请谨慎操作!',
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          groupDataDelete({ id })
            .then(() => {
              fetchData()
              toast({
                component: ToastificationContent,
                props: { title: '删除数据组数据成功', icon: 'CheckCircleIcon', variant: 'success' },
              })
            })
            .catch(err => {
              toast({
                component: ToastificationContent,
                props: { title: '删除数据组数据失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
              })
            })
        }
      })
    }

    // 更新数据组数据
    const upDateGroupData = data => {
      // 配置 valueMap 数据结构
      let groupData = { groupId: group_id.value, id: data.id, sort: data.sort, status: data.status }
      let valueMap = {}
      // 从 customerFieldsParams 中获取有哪些自定义字段
      customerFieldsParams.value.map(item => {
        valueMap[item.param] = { type: item.key, value: data[item.param] }
      })
      groupData.valueMap = valueMap
      groupDataSave(groupData)
        .then(() => {
          fetchData()
          toast({
            component: ToastificationContent,
            props: { title: '数据组数据更新成功', icon: 'CheckCircleIcon', variant: 'success' },
          })
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '数据组数据更新失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    /* 组件内部逻辑处理，生命周期问题处理区域 */
    onMounted(() => getHeader(router.currentRoute.params.id))

    return {
      pageShow,

      showEditModal,
      infoValue,
      tableHeaderArray,
      editClick,
      customerFieldsParams,
      showParamsText,

      fetchData,
      setStatus,
      deleteGroupData,
      upDateGroupData,

      gridOptions,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
